import React from 'react';
import { logger } from '@fiverr-private/obs';
import { Section, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { appTranslate } from '../../i18n';
import { SECTION_IDS } from '../../../consts';
import { ComeetEmbedConfig } from '../../../lib/comeet';
import { useBI, useImpression, SECTION_NAMES } from '../../bi';
import { ComeetApply } from './ComeetApply';
import { ComeetSocial } from './ComeetSocial';

interface ApplySectionProps {
    positionUid: string;
    comeetEmbedConfig?: ComeetEmbedConfig;
}

export const ApplySection = ({ positionUid, comeetEmbedConfig }: ApplySectionProps) => {
    const bi = useBI();
    const impressionRef = useImpression<HTMLDivElement>(() =>
        bi.reportSectionImpression({ sectionName: SECTION_NAMES.apply })
    );

    if (!comeetEmbedConfig || !comeetEmbedConfig.token || !comeetEmbedConfig.companyId) {
        logger.error(
            '[ApplySection] comeetEmbedConfig is missing or not full — setComeetEmbedConfig middleware did not run'
        );
        return null;
    }
    return (
        <Section fullWidth>
            <Stack
                ref={impressionRef}
                id={SECTION_IDS.apply}
                direction="column"
                alignItems="center"
                justifyContent="center"
                minHeight="480px"
                width="100%"
                paddingX={{ default: '5', md: '14' }}
                paddingY={{ default: '16', md: '28' }}
            >
                <Stack direction="column" alignItems="center" width="100%" maxWidth="881px">
                    <Typography
                        as="h2"
                        color="black"
                        fontWeight="semibold"
                        textAlign="center"
                        size={{ default: 'h_lg', md: 'h_xl' }}
                        letterSpacing="-2.4px"
                        marginBottom="20"
                        style={{ lineHeight: 1.08 }}
                    >
                        {appTranslate('job_page.apply.heading')}
                    </Typography>
                    <ComeetApply positionUid={positionUid} comeetEmbedConfig={comeetEmbedConfig} />
                    <ComeetSocial positionUid={positionUid} comeetEmbedConfig={comeetEmbedConfig} />
                </Stack>
            </Stack>
        </Section>
    );
};
